/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import MetaTags from 'react-meta-tags';
import {
  FaChevronRight, FaStar, FaAngleDown, FaArrowUp,
} from 'react-icons/fa';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import BottomScrollListener from 'react-bottom-scroll-listener';
import { ratings } from '../../queries';

import Filter from '../../components/Filter';
import Item from './Item';
import ReplyRatingModal from '../../components/Modal/Ratings/Reply';
import Loading from '../../components/Loading/Page';
import Footer from '../../components/Footer';

import { Content } from './styles';
import {
  Wrapper, Breadcrumb, EmptyList, ScrollTop,
} from '../../assets/styles';

class Ratings extends Component {
  constructor() {
    super();
    this.state = {
      filter: false,
      filterValue: {
        type: 'item',
        selected: null,
        value: 'Mais recentes',
      },
      selected: new Map(),
      offset: 0,
      hasMore: true,
      isLoading: false,
      updateFilterState: false,
      replyRatingModal: false,
      scrolling: false,
      replyRating: {},
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount = () => {
    document.removeEventListener('click', this.hideFilter);
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.scrollY < 300 && this.state.scrolling === true) {
      this.setState({ scrolling: false });
    } else if (window.scrollY > 300 && this.state.scrolling !== true) {
      this.setState({ scrolling: true });
    }
  }

  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  fetchMore = () => {
    if (this.state.hasMore) {
      this.setState(state => ({ offset: state.offset + 10, isLoading: true }));

      this.props.data.fetchMore({
        variables: {
          storeId: this.props.store.id,
          offset: this.state.offset,
          limit: 10,
          orderBy: this.state.filterValue.value !== 'Data'
            ? { type: this.state.filterValue.value }
            : {
              type: this.state.filterValue.value,
              startDate: this.state.filterValue.startDate,
              endDate: this.state.filterValue.endDate,
            },
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const { comments: prevComments } = previousResult.ratingsPortal.ratings;
          const { length, total, comments: newComments } = fetchMoreResult.ratingsPortal.ratings;

          this.setState({ isLoading: false });

          if (newComments.length === 0) {
            this.setState({ hasMore: false });

            return previousResult;
          }

          return {
            ratingsPortal: {
              ratings: {
                comments: [...prevComments, ...newComments],
                length,
                total,
              },
              __typename: 'Store',
            },
          };
        },
      });
    }
  }

  refetchQueries = () => {
    this.props.data.fetchMore({
      variables: {
        storeId: this.props.store.id,
        offset: 0,
        limit: this.state.offset === 0 ? 10 : (this.state.offset + 10),
        orderBy: this.state.filterValue.value !== 'Data'
          ? { type: this.state.filterValue.value }
          : {
            type: this.state.filterValue.value,
            startDate: this.state.filterValue.startDate,
            endDate: this.state.filterValue.endDate,
          },
      },
      updateQuery: (previousResult, { fetchMoreResult }) => fetchMoreResult,
    });
  }

  updateFilter = (filterValue) => {
    this.setState({ updateFilterState: true });

    this.props.data.fetchMore({
      variables: {
        storeId: this.props.store.id,
        offset: 0,
        limit: 10,
        orderBy: filterValue.value !== 'Data'
          ? { type: filterValue.value }
          : {
            type: filterValue.value,
            startDate: filterValue.startDate,
            endDate: filterValue.endDate,
          },
      },
      updateQuery: (previousResult, { fetchMoreResult }) => {
        this.setState({ updateFilterState: false });

        return fetchMoreResult;
      },
    });
  }

  handleFilter = (filterValue) => {
    this.setState({
      filterValue,
      filter: false,
      offset: 0,
      hasMore: true,
    }, () => {
      document.removeEventListener('click', this.hideFilter);
    });

    this.updateFilter(filterValue);
  }

  showFilter = async () => {
    await this.setState({ filter: true }, () => {
      document.addEventListener('click', this.hideFilter);
    });

    this.filterComponent.onMount(this.state.filterValue);
  }

  hideFilter = (e) => {
    if (!e.srcElement.offsetParent || e.srcElement.offsetParent.id !== 'filter') {
      this.setState({ filter: false }, () => {
        document.removeEventListener('click', this.hideFilter);
      });
    }
  }

  onPressItem = (id) => {
    this.setState((state) => {
      const selected = new Map(state.selected);
      selected.set(id, !selected.get(id));
      return { selected };
    });
  };

  replyItem = (ratingId, rating) => {
    this.setState({
      replyRating: {
        ratingId,
        userId: rating.clientInfo.id,
        orderId: rating.orderId,
        storeOrderId: rating.storeOrderId,
        comment: rating.text,
      },
    });

    this.openReplyRatingModal();
  }

  openReplyRatingModal = () => {
    this.replyRatingModal.openReplyRatingModal();

    this.setState({ replyRatingModal: true });
  };

  closeReplyRatingModal = () => {
    this.setState({ replyRatingModal: false });
  };

  render() {
    const {
      filter, filterValue, isLoading, updateFilterState,
    } = this.state;
    const { loading, ratingsPortal } = this.props.data;

    return (
      <div style={{ position: 'absolute', width: '100%' }}>
        <MetaTags>
          <title>Avaliações - Portal da Loja - Reforma Fácil</title>
          <meta name="robots" content="noindex" />
        </MetaTags>
        <Breadcrumb>
          <div className="container">
            <h2>Avaliações</h2>
            <FaChevronRight className="fas fa-chevron-right" />
            <h2 className="bold">Resumo</h2>
          </div>
        </Breadcrumb>
        <Wrapper>
          {(loading || updateFilterState) && <Loading />}
          {!loading && !updateFilterState && (
            <>
              {filter && (
              <Filter
                ref={(ref) => { this.filterComponent = ref; }}
                handleFilter={this.handleFilter}
                ratingPadding={ratingsPortal.ratings}
              />
              )}
              <Content filter={filter}>
                <div className="controls">
                  <div className="stats">
                    <div className="container">
                      <h3>Média geral</h3>
                      <span className="star">
                        <FaStar className="fa fa-star" />
                        {ratingsPortal.ratings.total === 0 ? 0 : parseFloat(ratingsPortal.ratings.total).toFixed(1).replace('.', ',')}
                      </span>
                    </div>
                    <div className="container">
                      <h3>Total de avaliações</h3>
                      <span>{ratingsPortal.ratings.length}</span>
                    </div>
                  </div>
                  <div className="list-controls">
                    <div className="items-found">
                      <span>{`${ratingsPortal.ratings.comments.length} item(s)`}</span>
                    </div>
                    <div className="filters" onClick={this.showFilter}>
                      <span className="text">{filterValue.value}</span>
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span className="separator" />
                        <FaAngleDown className="fas fa-angle-down" />
                      </div>
                    </div>
                  </div>
                </div>
                {ratingsPortal.ratings.comments.length === 0 ? (
                  <EmptyList>
                    <p>Nenhuma avaliaçao encontrada</p>
                  </EmptyList>
                ) : (
                  <>
                    {ratingsPortal.ratings.comments.map(item => (
                      <Item
                        key={item.id}
                        id={item.id}
                        item={item}
                        onPressItem={this.onPressItem}
                        replyItem={this.replyItem}
                        selected={!!this.state.selected.get(item.id)}
                      />
                    ))}
                  </>
                )}
                {isLoading && <Loading size={8} margin="1px" />}
                <Footer />
              </Content>
            </>
          )}
        </Wrapper>
        {this.state.scrolling && (
          <ScrollTop onClick={this.scrollToTop}>
            <FaArrowUp className="fa fa-arrow-up" />
            <span>Topo</span>
          </ScrollTop>
        )}
        <ReplyRatingModal
          ref={(el) => { if (el) this.replyRatingModal = el.getWrappedInstance(); }}
          open={this.state.replyRatingModal}
          close={this.closeReplyRatingModal}
          rating={this.state.replyRating}
          storeId={this.props.store.id}
          refetchQueries={this.refetchQueries}
        />
        <BottomScrollListener offset={100} onBottom={this.fetchMore} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state.store,
});

export default compose(
  connect(mapStateToProps, null),
  graphql(ratings, {
    options: props => ({
      fetchPolicy: 'network-only',
      variables: {
        storeId: props.store.id,
        offset: 0,
        limit: 10,
        orderBy: { type: 'Mais recentes' },
      },
    }),
  }),
)(Ratings);
